import Swiper from 'swiper/bundle';

/**
 * Export default article slider
 */
export default () => {
  function init() {
    const target = '#testimonials-two';
    const swiper2 = new Swiper(target, {
      slidesPerView: 3,
      loop: true,
      spaceBetween: 0,
      centeredSlides: false,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next--testimonials-two',
        prevEl: '.swiper-button-prev--testimonials-two',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        // when window width is >= 320px
        300: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        822: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,
        },
        1351: {
          slidesPerView: 3,
          spaceBetween: 0,
          centeredSlides: false,
        },
      },
    });
    swiper2.on('slideChange', () => {
      console.log('slide changed');
      // console.log(target.replace('#', ''));
      const videoEmbed = document
        .getElementById(target.replace('#', ''))
        .getElementsByClassName('wistia_embed');
      Array.prototype.forEach.call(videoEmbed, (videoLoad) => {
        // const videoHandle = videoLoad.getAttribute('data-video-handle');
        // console.log(`Slider video: ${videoId}`);
        window._wq = window._wq || [];
        _wq.push({
          id: '_all',
          onReady(video) {
            console.log('Stop video');
            video.pause();
          },
        });
      });
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
